"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getSelectionPath_1 = require("./getSelectionPath");
/**
 * Get inner Html of a root node with a selection path which can be used for restore selection.
 * The result string can be used by setHtmlWithSelectionPath() to restore the HTML and selection.
 * @param rootNode Root node to get inner Html from
 * @param range The range of selection. If pass null, no selection path will be added
 * @returns Inner HTML of the root node, followed by HTML comment contains selection path if the given range is valid
 */
function getHtmlWithSelectionPath(rootNode, range) {
    if (!rootNode) {
        return '';
    }
    var content = rootNode.innerHTML;
    var selectionPath = range && getSelectionPath_1.default(rootNode, range);
    return selectionPath ? content + "<!--" + JSON.stringify(selectionPath) + "-->" : content;
}
exports.default = getHtmlWithSelectionPath;
//# sourceMappingURL=getHtmlWithSelectionPath.js.map